import React, { useState } from 'react';
import './Legal.css';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import logo from '../assets/tizm.png';

const KVKK = ({ currentLang }) => {
  const [lang, setLang] = useState(currentLang === 'en' ? 'en' : 'tr');
  const content = {
    tr: {
      title: "SPORTİZM UYGULAMASI KİŞİSEL VERİLERİN KORUNMASI VE İŞLENMESİ AYDINLATMA METNİ",
      content: (
        <>
          <p>
            İşbu Aydınlatma Metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) uyarınca, Sportizm ("Uygulama") kullanıcılarının kişisel verilerinin işlenme usul ve esaslarına ilişkin olarak veri sorumlusu sıfatıyla bilgilendirilmesi amacıyla hazırlanmıştır.
          </p>

          <h3>1. Veri Sorumlusu</h3>
          <p>
            Sportizm Uygulama Yönetimi<br />
            Adres: [Buraya Açık Adresinizi Giriniz]<br />
            E-posta: [Buraya Destek/İletişim E-posta Adresinizi Giriniz]
          </p>

          <h3>2. İşlenen Kişisel Verileriniz ve İşleme Amaçları</h3>
          <p>Sportizm tarafından toplanan kişisel verileriniz, aşağıdaki amaçlar doğrultusunda KVKK’nın 5. ve 6. maddelerinde belirtilen kişisel veri işleme şartları dahilinde işlenecektir:</p>
          <ul>
            <li><strong>Kimlik ve İletişim Bilgileri:</strong> Ad-soyad, e-posta, telefon numarası, doğum tarihi. (Amacı: Üyelik oluşturulması, kullanıcı doğrulaması ve iletişim sağlanması).</li>
            <li><strong>Konum Bilgisi:</strong> İl, ilçe, adres ve anlık konum verileri. (Amacı: Bölgenizdeki spor tesislerinin, turnuvaların ve rakiplerin gösterilmesi).</li>
            <li><strong>Sporcu Profil Bilgileri:</strong> Cinsiyet, kullanılan el/ayak bilgisi, mevkii/pozisyon, ilgilenilen spor branşları (futbol, basketbol, tenis vb.). (Amacı: Size uygun rakiplerin ve takımların bulunması, sporcu profili oluşturulması).</li>
            <li><strong>Cihaz ve Kullanım Bilgileri:</strong> Google Analytics ve Firebase aracılığıyla toplanan kullanım istatistikleri ve cihaz bilgileri. (Amacı: Uygulama performansının artırılması ve push bildirimlerin gönderilmesi).</li>
          </ul>
          <p><em>Not: Sporcu profil bilgileri (el/ayak, mevki vb.) kullanıcının tercihine bağlı olarak gizlenebilir ve sadece kullanıcı izin verdiği ölçüde diğer kullanıcılar tarafından görüntülenebilir.</em></p>

          <h3>3. İşlenen Kişisel Verilerin Aktarımı</h3>
          <p>Kişisel verileriniz, yukarıda belirtilen amaçların gerçekleştirilmesi doğrultusunda şu kişilerle paylaşılabilecektir:</p>
          <ul>
            <li><strong>Spor Tesisleri:</strong> Tesis kiralama işleminin tamamlanabilmesi için ilgili halı saha, kort veya salon işletmecileri ile.</li>
            <li><strong>Hizmet Sağlayıcılar:</strong> Veri saklama ve analiz işlemleri için Firebase ve Google Analytics altyapıları ile (Bu veriler yurt dışı merkezli sunucularda tutulabilmektedir).</li>
            <li><strong>Diğer Kullanıcılar:</strong> Takım kurma ve maç teklifi süreçlerinde, profilinizde kamuya açık bıraktığınız bilgiler diğer kullanıcılar tarafından görüntülenebilir.</li>
          </ul>

          <h3>4. Kişisel Veri Toplamanın Yöntemi ve Hukuki Sebebi</h3>
          <p>
            Kişisel verileriniz, uygulamayı kullanırken doldurduğunuz formlar ve uygulamanın arka planında çalışan teknik takip araçları (SDK'lar) vasıtasıyla tamamen otomatik yollarla toplanmaktadır. Verileriniz, "Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması" ve "Veri sorumlusunun meşru menfaatleri" hukuki sebeplerine dayalı olarak işlenmektedir.
          </p>

          <h3>5. Veri Saklama ve Silme Hakkı</h3>
          <p>Sportizm, kullanıcılarına verileri üzerinde tam kontrol hakkı tanır.</p>
          <p><strong>Hesap Silme:</strong> Kullanıcılar, uygulama içerisindeki "Profilim &gt; Düzenle &gt; Hesabımı Sil" adımlarını takip ederek tüm verilerini ve hesaplarını diledikleri zaman kalıcı olarak silebilirler.</p>
          <p>Yasal bir yükümlülük olmadığı sürece, silinen veriler sunucularımızdan derhal kaldırılır.</p>

          <h3>6. İlgili Kişinin Hakları (KVKK Madde 11)</h3>
          <p>KVKK uyarınca herkes, veri sorumlusuna başvurarak kendisiyle ilgili;</p>
          <ul>
            <li>Kişisel veri işlenip işlenmediğini öğrenme,</li>
            <li>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,</li>
            <li>Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme,</li>
            <li>Kişisel verilerin silinmesini veya yok edilmesini isteme haklarına sahiptir.</li>
          </ul>
          <p>Bu haklarınızı kullanmak için yukarıda belirtilen e-posta adresine yazılı olarak başvuruda bulunabilirsiniz.</p>
        </>
      )
    },
    en: {
      title: "SPORTIZM APPLICATION PROTECTION AND PROCESSING OF PERSONAL DATA CLARIFICATION TEXT",
      content: (
        <>
          <p>
            This Clarification Text has been prepared in accordance with the Turkish Law No. 6698 on the Protection of Personal Data ("PDPL"), in order to inform the users of Sportizm (the "Application") in the capacity of data controller, regarding the procedures and principles of the processing of their personal data.
          </p>

          <h3>1. Data Controller</h3>
          <p>
            Sportizm Application Management<br />
            Address: [Enter Your Full Address Here]<br />
            E-mail: [Enter Your Support/Contact E-mail Address Here]
          </p>

          <h3>2. Personal Data Processed and Purposes of Processing</h3>
          <p>Your personal data collected by Sportizm will be processed within the scope of the personal data processing conditions specified in Articles 5 and 6 of the PDPL, for the following purposes:</p>
          <ul>
            <li><strong>Identity and Contact Information:</strong> Name-surname, e-mail, phone number, date of birth. (Purpose: Creating membership, user verification and providing communication).</li>
            <li><strong>Location Information:</strong> City, district, address and real-time location data. (Purpose: Displaying sports facilities, tournaments and opponents in your area).</li>
            <li><strong>Athlete Profile Information:</strong> Gender, dominant hand/foot, position, sports branches of interest (football, basketball, tennis, etc.). (Purpose: Finding suitable opponents and teams for you, creating an athlete profile).</li>
            <li><strong>Device and Usage Information:</strong> Usage statistics and device information collected via Google Analytics and Firebase. (Purpose: Improving application performance and sending push notifications).</li>
          </ul>
          <p><em>Note: Athlete profile information (hand/foot, position, etc.) can be hidden depending on the user's preference and can only be viewed by other users to the extent that the user permits.</em></p>

          <h3>3. Transfer of Processed Personal Data</h3>
          <p>Your personal data may be shared with the following parties in line with the realization of the purposes specified above:</p>
          <ul>
            <li><strong>Sports Facilities:</strong> With the relevant pitch, court or hall operators in order to complete the facility rental transaction.</li>
            <li><strong>Service Providers:</strong> With Firebase and Google Analytics infrastructures for data storage and analysis processes (This data may be kept on servers located abroad).</li>
            <li><strong>Other Users:</strong> During team building and match offer processes, information you leave public on your profile may be viewed by other users.</li>
          </ul>

          <h3>4. Method and Legal Reason for Collecting Personal Data</h3>
          <p>
            Your personal data is collected entirely through automated means via the forms you fill out while using the application and the technical tracking tools (SDKs) running in the background of the application. Your data is processed based on the legal reasons of "being directly related to the establishment or performance of a contract" and "the legitimate interests of the data controller".
          </p>

          <h3>5. Data Retention and Right to Erasure</h3>
          <p>Sportizm grants its users full control over their data.</p>
          <p><strong>Account Deletion:</strong> Users can permanently delete all their data and accounts at any time by following the "My Profile &gt; Edit &gt; Delete My Account" steps within the application.</p>
          <p>Unless there is a legal obligation, deleted data is immediately removed from our servers.</p>

          <h3>6. Rights of the Data Subject (PDPL Article 11)</h3>
          <p>Pursuant to the PDPL, everyone has the right to apply to the data controller and, regarding themselves;</p>
          <ul>
            <li>Learn whether personal data is being processed,</li>
            <li>Request information if personal data has been processed,</li>
            <li>Request correction of personal data in case it has been processed incompletely or incorrectly,</li>
            <li>Request the deletion or destruction of personal data.</li>
          </ul>
          <p>To exercise these rights, you may apply in writing to the e-mail address specified above.</p>
        </>
      )
    }
  };

  const t = content[lang] || content.tr;

  return (
    <div className="legal-page">
      <Helmet>
        <title>{t.title} - Sportizm</title>
        <meta name="description" content={t.title} />
      </Helmet>
      
      <div className="legal-container">
        <div className="legal-header">
           <Link to="/">
            <img src={logo} alt="Sportizm" className="legal-logo" />
          </Link>
          <div className="legal-lang-switch">
            <button
              type="button"
              className={`legal-lang-btn ${lang === 'tr' ? 'active' : ''}`}
              onClick={() => setLang('tr')}
            >
              TR
            </button>
            <button
              type="button"
              className={`legal-lang-btn ${lang === 'en' ? 'active' : ''}`}
              onClick={() => setLang('en')}
            >
              EN
            </button>
          </div>
          <h1>{t.title}</h1>
        </div>
        
        <div className="legal-content">
          {t.content}
        </div>
      </div>
    </div>
  );
};

export default KVKK;
